<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12" md="6">
        <v-text-field outlined dense v-model="bias" @change="updateTables" label="Enter Data Bias"/>
      </v-col>
      <v-col cols="12" md="6">
        <v-autocomplete :items="polls" outlined dense chips deletable-chips small-chips item-value="id" item-text="id"
                        label="Select Poll" @change="getPolls"/>
        <!--        <v-btn large class="primary" @click="getPolls">-->
        <!--          <v-icon>mdi-refresh</v-icon>-->
        <!--          Refresh-->
        <!--        </v-btn>-->
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12" md="12">
        <v-card v-if="poll">
          <v-card-title class="justify-center text-center">Poll # [{{ poll.id }} ]</v-card-title>
          <v-card-text>
            <v-simple-table v-for="(item,i) in sms.length" class="mb-4">
              <template v-slot:default>
                <thead>
                <tr>
                  <td colspan="4">
                    <h2>{{ sms[i].question }}</h2>
                  </td>
                </tr>
                <tr>
                  <th class="text-left">
                    #
                  </th>
                  <th class="text-left">
                    Candidate
                  </th>
                  <th class="text-left">
                    Votes
                  </th>
                  <th class="text-left">
                    Percentage %
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="(item,i) in sms[i].poll_options"
                    :key="i"
                >
                  <td>{{ i + 1 }}</td>
                  <td> {{ item.option }}</td>
                  <td>{{ item.votes }}</td>
                  <td>
                    {{
                      ((item.votes / sms[0].poll_options.map(bill => bill.votes).reduce((acc, bill) => bill + acc)) * 100).toFixed(0)
                    }}
                    %
                  </td>
                </tr>
                <tr class="font-weight-bold">
                  <td></td>
                  <td>Total</td>
                  <td>{{
                      ((sms[0].poll_options.map(bill => bill.votes).reduce((acc, bill) => bill + acc))).toFixed(0)
                    }}
                  </td>
                  <td>100</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-divider class="ma-3 green"/>
          </v-card-text>
        </v-card>
        <v-card v-else>
          <v-card-title>

          </v-card-title>
          <v-card-text>
            Please Select a poll to Review
          </v-card-text>

        </v-card>
      </v-col>
      <v-col cols="12" md="12" v-if="poll">
        <v-card class="mb-4">
          <v-card-text class="mb-4">
            <h2>Live Poll Statistics</h2>
            <v-card class="mb-4">
              <v-card-text>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                    <tr>
                      <th class="text-left">
                        Mechanism
                      </th>
                      <th class="text-left">
                        Questions
                      </th>
                      <th class="text-left">
                        Sent
                      </th>
                      <th class="text-left">
                        Responses
                      </th>
                      <th class="text-left">
                        Response Percentage %
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td>Ussd</td>
                      <td>{{ poll.qCount }}</td>
                      <td>{{ poll.cost }}</td>
                      <td>{{
                          ((sms[0].poll_options.map(bill => bill.votes).reduce((acc, bill) => bill + acc))).toFixed(0)
                        }}
                      </td>
                      <td>{{
                          (((sms[0].poll_options.map(bill => bill.votes).reduce((acc, bill) => bill + acc) / poll.cost) * 100)).toFixed(0)
                        }}
                      </td>
                    </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
            </v-card>
            <table-widget v-if="poll.level==='county'" :table-row-data="constituencyData" :headers="headers"
                          title="Constituency Analysis"/>
            <table-widget :table-row-data="wardData" v-if="poll.level==='constituency'" :headers="headers" title="Ward Analysis"/>
            <table-widget :table-row-data="pollingData" :headers="headers" title="Polling Station Analysis"/>
            <v-row dense>
              <v-col cols="12">
                Ward BreakDown
              </v-col>
              <v-col cols="12" md="6" v-for="(wardSummary,i) in wardSummaryData" class="">
                <!--                <poll-table :i="i" :ward-summary="wardSummary"/>-->
                <nested-table :key="t1" :bias="bias" v-if="poll" :table-data="wardSummary[0]" :title="i + ' Ward'"/>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                Polling Center Details
              </v-col>
              <v-col cols="12" md="6" v-for="(wardSummary,i) in pollingSummaryData" class="">
                <!--                <poll-table :i="i" :ward-summary="wardSummary"/>-->
                <nested-table :key="t2" :bias="bias" v-if="poll" :table-data="wardSummary[0]" :title="i"/>
              </v-col>
            </v-row>

            <v-divider class="ma-3 green"/>

          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {getRequest} from "@/api/apirepository";
import TableWidget from "@/components/widgets/tables/TableWidget";
import PollTable from "@/components/widgets/tables/PollTable";
import NestedTable from "@/components/widgets/tables/nestedTable";

export default {
  name: "PollResults",
  components: {NestedTable, PollTable, TableWidget},
  data: () => ({
    skill: 20,
    bias: 1,
    t1: 1,
    t2: 1,
    knowledge: 33,
    power: 78,
    sms: [],
    polls: [],
    constituencyData: [],
    wardData: [],
    wardSummaryData: [],
    pollingData: [],
    selectedPoll: [],
    pollingSummaryData: [],
    poll: null,
    headers: [
      {
        text: 'Name',
        align: 'left',
        sortable: true,
        value: 'name',
      },
      {text: 'Votes Cast', value: 'count'},
      {text: 'Percentage', value: 'percent'},
    ],
    desserts: [
      {
        name: 'Ndindi Nyoro',
        number: 1,
        votes: 159,
        percent: 51,
      },
      {
        name: 'Others',
        number: 2,
        votes: 140,
        percent: 49,
      },
    ]
  }),
  methods: {
    updateTables() {
      this.t1++
      this.t2++
    },
    getSMSCampaigns() {
      getRequest('ussdPoll').then(({data}) => {
        this.polls = data;
      }).catch(e => {
        console.log(e)
      })
    },
    getPolls(e) {
      this.selectedPoll = e;
      getRequest('getPollDetails', {
        params: {
          pollId: e,
        }
      }).then(({data}) => {
        this.sms = data.questions;
        this.poll = data.poll;
        if (this.poll.level === 'county') {
          this.getConstituencyResultsPolls()
          this.getWardResultsPolls()
          this.getQuestionFromVote()
          this.getQuestionFromPollingVote()
          this.getPollingStationResultsPolls()
        } else if (this.poll.level === 'constituency') {
          this.getWardResultsPolls()
          this.getQuestionFromVote()
          this.getQuestionFromPollingVote()
          this.getPollingStationResultsPolls()
        } else if (this.poll.level === 'ward') {
          // this.getWardResultsPolls()
          this.getQuestionFromVote()
          this.getQuestionFromPollingVote()
          this.getPollingStationResultsPolls()
        } else if (this.poll.level === 'pollingstation') {
          this.getPollingStationResultsPolls()
        }
      }).catch(e => {
        console.log(e)
      })
    },
    getWardResultsPolls() {
      getRequest('getResultsByWards', {
        params: {
          id: this.$store.state.user.id,
          pollId: this.selectedPoll
        }
      }).then(({data}) => {
        this.wardData = data.map(item => {
          return {
            ...item,
            count: item.count,
            percent: ((item.count / this.sms[0].poll_options.map(bill => bill.votes).reduce((acc, bill) => bill + acc)) * 100).toFixed(0) + "%"
          }
        });
        // console.log(data)
      }).catch(e => {
        console.log(e)
      })
    },
    getConstituencyResultsPolls() {
      getRequest('getResultsByConstituencies', {
        params: {
          id: this.$store.state.user.id,
          pollId: this.selectedPoll
        }
      }).then(({data}) => {
        this.constituencyData = data.map(item => {
          return {
            ...item,
            count: item.count,
            percent: ((item.count / this.sms[0].poll_options.map(bill => bill.votes).reduce((acc, bill) => bill + acc)) * 100).toFixed(0) + "%"
          }
        });
        // console.log(data)
      }).catch(e => {
        console.log(e)
      })
    },
    getQuestionFromVote() {
      getRequest('getQuestionFromVote', {
        params: {
          id: this.$store.state.user.id,
          pollId: this.selectedPoll
        }
      }).then(({data}) => {
        this.wardSummaryData = data;
        // console.log(data)
      }).catch(e => {
        console.log(e)
      })
    },
    getQuestionFromPollingVote() {
      getRequest('getQuestionFromPollingVote', {
        params: {
          id: this.$store.state.user.id,
          pollId: this.selectedPoll
        }
      }).then(({data}) => {
        this.pollingSummaryData = data;
        // console.log(data)
      }).catch(e => {
        console.log(e)
      })
    },
    getPollingStationResultsPolls() {
      getRequest('getResultsByPollingStations', {
        params: {
          id: this.$store.state.user.id,
          pollId: this.selectedPoll
        }
      }).then(({data}) => {
        this.pollingData = data.map(item => {
          return {
            ...item,
            count: item.count,
            percent: ((item.count / this.sms[0].poll_options.map(bill => bill.votes).reduce((acc, bill) => bill + acc)) * 100).toFixed(0) + "%"
          }
        });
        // console.log(data)
      }).catch(e => {
        console.log(e)
      })
    }
  },
  created() {
    // this.getPolls()
    // this.getWardResultsPolls()
    this.getSMSCampaigns()
    // this.getQuestionFromVote()
  }
}
</script>

<style scoped>

</style>